import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeDataEventStepConfigComponent } from './change-data-event-step-config/change-data-event-step-config.component';
import { ConditionStepConfigComponent } from './condition-step-config/condition-step-config.component';
import { DelayStepConfigComponent } from './delay-step-config/delay-step-config.component';
import { EmailEventStepConfigComponent } from './email-event-step-config/email-event-step-config.component';
import { LandingPageEventStepConfigComponent } from './landing-page-event-step-config/landing-page-event-step-config.component';
import { SmsStepConfigComponent } from './sms-step-config/sms-step-config.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ComponentsModule } from '../components.module';
import { ChipsModule } from 'primeng/chips';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { EmailStepConfigComponent } from './email-step-config/email-step-config.component';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { DatePickerModule } from 'primeng/datepicker';
import {TranslateLoader, TranslateModule, TranslatePipe} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TooltipModule } from 'primeng/tooltip';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SaveQueryStepConfigComponent } from './save-query-step-config/save-query-step-config.component';

const exportsStepCmp = [
  ChangeDataEventStepConfigComponent,
  ConditionStepConfigComponent,
  DelayStepConfigComponent,
  EmailEventStepConfigComponent,
  LandingPageEventStepConfigComponent,
  SaveQueryStepConfigComponent,
  SmsStepConfigComponent,
  EmailStepConfigComponent
]

@NgModule({
  declarations: [
    ...exportsStepCmp
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        DropdownModule,
        ComponentsModule,
        ChipsModule,
        InputTextModule,
        InputNumberModule,
        CheckboxModule,
        ButtonModule,
        MultiSelectModule,
        DatePickerModule,
        TooltipModule,
        InputSwitchModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader,
            },
            isolate: false,
        }),
        TranslatePipe,
    ],
  exports: [
    ...exportsStepCmp
  ]
})
export class WorkflowStepConfigModule { }
